export const Svg_121 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M5.834 61.25v-4.375h26.979V21.584c-1.264-.438-2.394-1.155-3.39-2.151-.997-.997-1.714-2.127-2.152-3.39H15.677l9.115 22.02c-.049 2.187-.984 4.047-2.807 5.578-1.823 1.531-4.047 2.297-6.672 2.297s-4.85-.766-6.672-2.297c-1.823-1.531-2.759-3.39-2.807-5.578l9.114-22.02H8.75v-4.376h18.521a8.81 8.81 0 0 1 2.99-4.193c1.41-1.093 2.99-1.64 4.74-1.64s3.33.547 4.739 1.64a8.81 8.81 0 0 1 2.99 4.193h18.52v4.375h-6.197l9.114 22.02c-.049 2.188-.984 4.048-2.807 5.579-1.823 1.531-4.047 2.297-6.672 2.297s-4.849-.766-6.672-2.297c-1.823-1.531-2.759-3.39-2.807-5.578l9.114-22.02H42.73c-.438 1.263-1.155 2.393-2.151 3.39-.997.996-2.127 1.713-3.391 2.15v35.292h26.98v4.375H5.833Zm43.385-23.333h10.938L54.687 24.5 49.22 37.917Zm-39.375 0h10.938L15.312 24.5 9.845 37.917ZM35 17.5c1.021 0 1.884-.364 2.589-1.093.705-.73 1.057-1.58 1.057-2.552 0-1.021-.352-1.884-1.057-2.589-.705-.705-1.568-1.057-2.589-1.057-.972 0-1.822.352-2.552 1.057-.729.705-1.093 1.568-1.093 2.589 0 .972.364 1.822 1.093 2.552.73.729 1.58 1.093 2.552 1.093Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={19.323}
        x2={45.022}
        y1={14.146}
        y2={57.927}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)